import React, { useState } from 'react';
import { DataList, Loader } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../../useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

import { columnConfigs } from './listConfig';

const WebsiteUpdateInfoList: React.FC<{}> = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setShowLoader
	});
	const actions = getActionList();

	const { requestGetWebsiteUpdateInfoList } = useService();

	return (
		<>
			{showLoader && <Loader />}
			<div style={{ fontWeight: 'bold', padding: '10px', backgroundColor: '#f5f5f5' }}> OREO </div>
			<DataList
				fetchData={requestGetWebsiteUpdateInfoList}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.APK_WEB}
				initialSortDirection='DESC'
				initialSortIndex={1}
			/>
		</>
	);
};

export default WebsiteUpdateInfoList;
